import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group relative block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-200 hover:-translate-y-1"
      data-product-shop="comic"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} · ${comic.category}漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-xs font-medium text-background-50 ${comic.status === '已完结' ? 'bg-accent-500' : 'bg-primary-500'}`}>
          {comic.status}
        </span>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-background-950/70 text-sm font-bold text-background-50 backdrop-blur">
            {rank}
          </span>
        )}
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 transition-opacity duration-200 group-hover:opacity-100">
          <span className="w-full px-3 py-2 text-center text-sm text-background-50">开始阅读</span>
        </div>
      </div>
      <div className="p-3">
        <h4 className="truncate text-sm font-semibold text-foreground-900">{comic.title}</h4>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-fire-fill text-primary-500"></i>
          <span>{comic.rating}分</span>
          <span className="text-foreground-300">·</span>
          <span>{comic.views}人气</span>
        </p>
        <p className="mt-1 text-xs text-foreground-400">{comic.latestChapter} / {comic.totalChapters}话</p>
      </div>
    </Link>
  );
}